/**
 * @file index.js
 * @description Globals initialization
 */

import initializeDatePicker from '../../modules/date'

/**
 * Initialize global services
 */
export default async function initializeGlobals() {
    try {
        initializeDatePicker()
    } catch (error) {
        console.error('Globals initialization failed:', error)
    }
}
